import { cn } from "@/lib/utils";

interface Props {
  className?: string;
  /**
   * `true` (défaut) → logo complet (icône + mot "SUPER·PARI").
   * `false` → version "mark" (icône seule, sans le mot). Si
   * `/logo-mark.png` n'existe pas, on retombe sur le logo complet.
   */
  showWord?: boolean;
  size?: "sm" | "md" | "lg" | "xl";
}

const HEIGHTS = {
  sm: "h-6",
  md: "h-10",
  lg: "h-16",
  xl: "h-24",
} as const;

export function Logo({ className, showWord = true, size = "md" }: Props) {
  const src = showWord ? "/logo.png" : "/logo-mark.png";
  return (
    <img
      src={src}
      alt="Super-Pari"
      className={cn(HEIGHTS[size], "w-auto select-none", className)}
      draggable={false}
      onError={(e) => {
        // Fallback : si /logo-mark.png n'a pas encore été fourni, on
        // bascule silencieusement sur le logo complet pour ne pas casser
        // les pages qui demandent la version mark.
        const img = e.currentTarget;
        if (img.src.endsWith("/logo-mark.png")) img.src = "/logo.png";
      }}
    />
  );
}
